module.exports = __webpack_public_path__ + "static/spaceballs-jam-1814ec65e7084e68466714b096bbdc9f.gif";